module.exports = __webpack_public_path__ + "img/icon_system_home.59b6ea4a.svg";